import Vue from 'vue';
import { ActionTree, MutationTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import cloneDeep from 'lodash/cloneDeep';
import { saveAs } from 'file-saver';
import { fetchEnumsFromSchema } from '@/core/tools/forms/fetch_enums_from_schema';
import moment from 'moment';

interface ShiftVDPLaboratoryState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    documentId: any;
    clientId: any;
    meta: any;
    schema: any;

    // productList: any[];
    // productVariantList: any[];
    prefereds: any;
    relatedFactsList: any[];

    targetForDelete: any[];
    // inWorkStatus: any;
    // formationStatus: any;
    // products: any[];
    remains: any[];
}

const state: ShiftVDPLaboratoryState = {
    loading: false,
    loaded: false,
    fatalError: false,

    documentId: null,
    clientId: null,
    meta: null,
    schema: null,

    // productList: [],
    // productVariantList: [],
    prefereds: [],
    relatedFactsList: [],

    targetForDelete: [],
    // products: [],
    remains: []
};

const initState: any = cloneDeep(state);

const GET_SHIFT_CLOTS_VDP = 'GET_SHIFT_CLOTS_VDP';
const SHIFT_CLOTS_SCHEMA = 'GET_SHIFT_CLOTS_SCHEMA';


export const actions: ActionTree<ShiftVDPLaboratoryState, RootState> = {
    reset({ commit }) {
        commit('RESET_STATE')
    },

    loadData({ commit, getters, dispatch, state }, { documentId, clientId, remains }) {
        const vm = (this as any)._vm;
        commit('START_LOADING');

        state.documentId = documentId;
        state.clientId = clientId;
        state.remains = remains;

        return new Promise((resolve, reject) => {
          vm.$db([
            vm.$q(GET_SHIFT_CLOTS_VDP)
              .raw('documents.list')
              .action({
                columns: {
                  id: 'svl.id',
                  datetime: 'svl.datetime',
                  plan_id: 'spv.id',
                  plan_number: 'spv.number',
                  base_name: 'vb.name',
                  starter_type_name: 'vst.name',
                  shift_date: 's.shift_date',
                  extract_time: 'sfv.extract_time',
                  acidity_ohaus: 'svl.acidity_ohaus',
                  acidity_mettler: 'svl.acidity_mettler',
                  density_pp: 'svl.density_pp',
                  speed: 'svl.speed',
                  viscosity_pp: 'svl.viscosity_pp',
                  resistance_pp: 'svl.resistance_pp',
                  temp_pp: 'svl.temp_pp',
                },
                from: 's:shift_vdp_laboratory',
                from_as: 'svl',
                joins: [
                  {
                    join: 's:shift_plan_vdp',
                    type: 'left',
                    as:   'spv',
                    on: {
                      $eq: ['svl.plan_id', 'spv.id']
                    }
                  },
                  {
                    join: 's:shift_fact_vdp',
                    type: 'left',
                    as:   'sfv',
                    on: {
                      $eq: ['sfv.shift_plan_id', 'spv.id']
                    }
                  },
                  {
                    join: 's:shifts',
                    type: 'left',
                    as:   's',
                    on: {
                      $eq: ['spv.shift_id', 's.id']
                    }
                  },
                  {
                    join: 's:voc_bases',
                    type: 'left',
                    as:   'vb',
                    on: {
                      $eq: ['spv.base_id', 'vb.id']
                    }
                  },
                  {
                    join: 's:voc_starter_types',
                    type: 'left',
                    as:   'vst',
                    on: {
                      $eq: ['vst.id', 'spv.starter_type_id']
                    }
                  },
                ],
                page_size: 1000,
                page: 1,
                order: [
                  {$desc: ['svl.datetime']},
                  {$desc: ['svl.id']}
                ],
                where: {
                  $or: [
                    {$eq: [`spv.shift_id`, {$: documentId}]},
                  ]
                }
              }),
              vm.$q(SHIFT_CLOTS_SCHEMA)
              .raw('schemas.get')
              .action({
                  id: `s:shift_clot_vdp`
              }),
          ]).then((result: ServerResult) => {
            commit('LOADED_SUCCESS');
            const opRelResult = result.getOperation(GET_SHIFT_CLOTS_VDP);
            if (!opRelResult.hasError()) {
              state.relatedFactsList = opRelResult.getContent().documents.map((item: any) => {
                item.delay_time = null;
                if (item.datetime && item.extract_time) {
                  const _start = moment('1970-01-01 00:00:00').add(moment.duration(moment(item.datetime).diff(moment(item.extract_time))))
                  item.delay_time = _start.format('HH:mm:ss')
                }
                return item
              })
            }

            const opRelSchema = result.getOperation(SHIFT_CLOTS_SCHEMA);
            if (!opRelSchema.hasError()) {
              state.schema = opRelSchema.getContent().schema
              state.meta = fetchEnumsFromSchema(state.schema)
            }

            resolve(null);
          });
        })
    },

    exportAsXLSX({rootState, state}, {documentId}) {
      const vm = (this as any)._vm;

      return new Promise((resolve, reject) => {
          vm.$db([
              vm.$q('EXPORT')
              .raw('documents.report')
              .action({
                template: `
<!DOCTYPE html>
<table font=Verdana font-size=10 orientation="portrait" area="A:K" scale="45">
<tr height=30>
  <td wrap border bold bgcolor=FF72BF44 width=30>Время измерения</td>
  <td wrap border bold bgcolor=FF72BF44 width=25>Момент истины</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Термокамера</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Расположение паллета</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>№ партии</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Наименование базы</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>№ ряда</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>№ ведра</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>t °С</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>рН теплого сгустка</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Степень упругости</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Глубина колкости от поверхности ведра</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Характеристика сгустка, если не колкий</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Уровень качества</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Инцидент</td>
</tr>
{{#clots.documents}}
  <tr height="auto">
    <td wrap border type="date" date-format="DD.MM.YYYY HH:mm">{{datetime}}</td>
    <td wrap border >{{moment}}</td>
    <td wrap border >{{termocamera}}</td>
    <td wrap border >{{direct}}</td>
    <td wrap border >{{plan_number}}</td>
    <td wrap border base>{{base_name}}</td>
    <td wrap border >{{row_number}}</td>
    <td wrap border >{{bucket_number}}</td>
    <td wrap border >{{temp}}</td>
    <td wrap border >{{acidity}}</td>
    <td wrap border >{{elasticity_name}}</td>
    <td wrap border >{{causticity_name}}</td>
    <td wrap border >{{characteristic}}</td>
    <td wrap border >-</td>
    <td wrap border >{{incident_type_name}} / {{incident_sub_type_name}}</td>
  </tr>
{{/clots.documents}}
</table>
                `,
                queries: {
                  clots: {
                    columns: {
                      id: 'scv.id',
                      datetime: 'scv.datetime',
                      plan_number: 'spv.number',
                      shift_date: 's.shift_date',
                      moment: 'scv.moment',
                      termocamera: 'scv.termocamera',
                      direct: 'scv.direct',
                      row_number: 'scv.row_number',
                      base_name: {$concat: ['b.name', {$: ' '}, 'vst.name']},
                      bucket_number: 'scv.bucket_number',
                      temp: 'scv.temp',
                      acidity: 'scv.acidity',
                      elasticity_name: 've.name',
                      causticity_name: 'vc.name',
                      characteristic: 'scv.characteristic',
                      incident_sub_type_name: 'ist.name',
                      incident_type_name: 'it.name',
                    },
                    from: 's:shift_clot_vdp',
                    from_as: 'scv',
                    joins: [
                      {
                        join: 's:shifts',
                        type: 'left',
                        as:   's',
                        on: {
                          $eq: ['s.id', 'scv.shift_id']
                        }
                      },
                      {
                        join: 's:shift_plan_vdp',
                        type: 'left',
                        as:   'spv',
                        on: {
                          $eq: ['spv.id', 'scv.plan_id']
                        }
                      },
                      {
                        join: 's:voc_bases',
                        type: 'left',
                        as:   'b',
                        on: {
                          $eq: ['b.id', 'spv.base_id']
                        }
                      },
                      {
                        join: 's:voc_starter_types',
                        type: 'left',
                        as:   'vst',
                        on: {
                          $eq: ['vst.id', 'spv.starter_type_id']
                        }
                      },
                      {
                        join: 's:voc_elasticities',
                        type: 'left',
                        as:   've',
                        on: {
                          $eq: ['ve.id', 'scv.elasticity_id']
                        }
                      },
                      {
                        join: 's:voc_causticities',
                        type: 'left',
                        as:   'vc',
                        on: {
                          $eq: ['vc.id', 'scv.causticity_id']
                        }
                      },
                      {
                        join: 's:incident_sub_types',
                        type: 'left',
                        as:   'ist',
                        on: {
                          $eq: ['ist.id', 'scv.incident_sub_type_id']
                        }
                      },
                      {
                        join: 's:incident_types',
                        type: 'left',
                        as:   'it',
                        on: {
                          $eq: ['it.id', 'ist.incident_type_id']
                        }
                      },
                    ],
                    order: [
                      {$asc: ['scv.id']}
                    ],
                    where: {
                      $or: [
                        {$eq: [`scv.shift_id`, {$: documentId}]},
                        {$eq: [`scv.shift_id`, {$: documentId}]},
                      ]
                    }
                  },
                },
                format: 'xlsx'
              })
          ]).then(((result: ServerResult) => {
              const exportOpContent = result.getOperation('EXPORT').getContent();
              const fToken = exportOpContent.token;
              const aToken = (rootState as any).ubic.token
              const fileUrl = `${process.env.VUE_APP_UBIC_SERVER_ADDRESS}/api/v1/exports/${fToken}?authorization=${aToken}`;
              saveAs(fileUrl, 'export.xlsx')

              resolve();
          }));
      })
    }
};

export const mutations: MutationTree<ShiftVDPLaboratoryState> = {
  RESET_STATE: (state) => {
      for(const key in initState) {
          (state as any)[key] = initState[key]
      }
  },
  START_LOADING: (state) => {
      state.loaded = false;
      state.loading = true;
      state.fatalError = false;
  },
  LOADED_SUCCESS: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = false;
  },
  LOADED_ERROR: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = true;
  },

  // SET_DEAL_DATA(state, data) {
  //     const schema = data.schema;
  //     const document = data.documents[0];

  //     state.document = document
  // },

  // SET_DEAL_PRODRUCTS(state, data) {
  //     state.products = data.documents;
  // },

  // SET_STATUSES_INFO(state, {inWorkStatus, formationStatus}) {
  //     state.inWorkStatus = inWorkStatus;
  //     state.formationStatus = formationStatus;
  // },
};

export const getters: GetterTree<ShiftVDPLaboratoryState, RootState> = {
  totals : (state: ShiftVDPLaboratoryState) => {
    return {
      sum: state.relatedFactsList.reduce((val: number, item: any) => {
        return val + (parseFloat(item.container_price) || 0)
      }, 0)
    }
  },
  finalRelatedFactsList: (state: ShiftVDPLaboratoryState) => {
    return Object.values(state.relatedFactsList.reduce((prev: any, item: any) => {
      if (!prev[item.plan_number] || item.direct == 'up' || prev[item.plan_number].direct == 'down') {
        prev[item.plan_number] = item
      }
      return prev
    }, {}))
  },
  groupByPlan: (state: ShiftVDPLaboratoryState) => {
    const names = state.schema.fields.reduce((prev: any, field: any) => {
      prev[field.code] = field.name
      return prev
    }, {})
    const evenDatetime = state.relatedFactsList.reduce((prev: any, item: any) => {
      if (!prev[item.plan_number] ) {
        prev[item.plan_number] = []
      }
      if (!prev[item.plan_number].includes(item.datetime || '-')) {
        prev[item.plan_number].push(item.datetime || '-')
      }
      return prev
    }, {})
    return Object.values(state.relatedFactsList.reduce((prev: any, item: any) => {
      if (!prev[item.plan_number]) {
        prev[item.plan_number] = {
          plan_number: item.plan_number,
          base_name: item.base_name,
          class_row: evenDatetime[item.plan_number].indexOf(item.datetime || '-') % 2 !== 0 ? 'is-even-datetime' : '',
          laboratory: {
            class_row: [],
            rows: [],
          },
        }
      }
      Object.keys(item).map((key: any) => {
        if (!prev[item.plan_number].laboratory[key]) {
          prev[item.plan_number].laboratory[key] = []
        }
        prev[item.plan_number].laboratory[key].push(item[key])
      })
      prev[item.plan_number].laboratory.rows.push(item)
      prev[item.plan_number].laboratory.class_row.push(evenDatetime[item.plan_number].indexOf(item.datetime) % 2 !== 0 ? 'is-even-datetime' : '')
      return prev
    }, {})).sort((a: any, b: any) => {
      const keyA = parseFloat(a.plan_number);
      const keyB = parseFloat(b.plan_number);
      const result = (keyA > keyB) ? 1 : ((keyA < keyB) ? -1 : 0)
      return result
    })
  }
};

export const STORE_KEY = '$_shift_vdp_laboratory_list';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
